import { CommunitiesOverviewDTO } from '../dtos/Communities.dto';
import { CommunitiesOverviewModel } from '../models/CommunitiesOverview.model';

export class CommunitiesOverviewUtil {
  public static mapToViewModel(
    dto: CommunitiesOverviewDTO,
  ): CommunitiesOverviewModel {
    return {
      id: dto.id,
      logo: dto.logo,
      community: dto.name,
      subscription: dto.sub,
      posts: dto.monthly,
      members: dto.members,
      guests: dto.guests,
      status: dto.status,
      population: dto.population,
      created: dto.created,
    };
  }
}
